import { useEffect, useRef, useState } from "react";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import { Box, Tab, Tabs } from "@mui/material";
import "./OverallPerformanceDashboard.css"; // Assuming you have a CSS file for styling
import CoursesSelectFilter from "./CoursesSelectfilter";
import StudentSelectfilter from "./StudentSelectfilter";
import AIFeedbackPerformance from "./AIFeedbackPerformance";
import OverallPerformanceGraph from "./OverallPerformanceGraph";
import { addDays, format } from "date-fns";
import "react-date-range/dist/styles.css"; // import styles
import "react-date-range/dist/theme/default.css"; // import default theme
import EventOverViewGraph from "./EventOverViewGraph";
import {
  resetStudentList,
} from "../../state/actions/getEnrolledStudentListAction";
import { getEventOverviewByTeacher } from "../../state/actions/getEventOverviewByTeacherAction";
import { getEventOverviewByStudent } from "../../state/actions/getEventOverviewByStudentAction";
import { Token } from "@mui/icons-material";
import { useDispatch, useSelector } from "react-redux";
import { useAuth } from "../../features/auth/AuthContext";
import CalendarView from "./CalendarView";
import { useTheme } from "@mui/material/styles";
import dayjs from "dayjs";
import tooltip_trangle from "../../assets/images/tooltip_trangle.png";
import { resetCourseList } from "../../state/actions/getAiFeedbackPointByTeacherAction";
import { Chart_data } from "../../assets/images/images";
import FloatingAIButton from "../FloatingAIButton/FloatingAIButton";
import { setDrawerState, setIsWebAllowed, setQueryMetaData } from "../../state/reducers/chatDrawerReducers";
// import { Area, AreaChart, CartesianGrid, ResponsiveContainer, XAxis, YAxis } from 'recharts';

const OverallPerformanceDashboard = () => {
  // Helper function to convert month number to month name (MMM format)
  const getMonthName = (monthNumber) => {
    const months = [
      "Jan", "Feb", "Mar", "Apr", "May", "Jun",
      "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
    ];
    const validMonth = parseInt(monthNumber, 10);
    if (isNaN(validMonth) || validMonth < 1 || validMonth > 12) {
      return "Jan";
    }
    return months[validMonth - 1];
  };

  // Helper function to get default dates
  const getDefaultDates = () => {
    const now = new Date();
    const currentYear = now.getFullYear();
    const currentMonth = now.getMonth() + 1; // getMonth() returns 0-11, so add 1

    // Format month with leading zero if needed
    const formattedMonth =
      currentMonth < 10 ? `0${currentMonth}` : currentMonth;

    // Create start date (first day of current month)
    const startDate = `01-${formattedMonth}-${currentYear}`;

    // Create end date (21 days after start date)
    const startDateObj = new Date(currentYear, currentMonth - 1, 1); // Month is 0-indexed
    const endDateObj = addDays(startDateObj, 20); // Add 20 days to get 21 days total

    const endDate = format(endDateObj, "dd-MM-yyyy");

    return { startDate, endDate };
  };

  const {
    startDate: defaultStartDate,
    endDate: defaultEndDate,
  } = getDefaultDates();

  const [dot, setdot] = useState(""); // State to track clicked dot data
  //console.warn("dot Dash", dot);

  // Custom setdot function that clears calendar selection when dot is clicked
  const handleDotClick = (dotData) => {
    setdot(dotData);
    // Clear calendar selection state to prioritize dot data
    setCalendarSelectionMade(false);
    // Don't clear month_year here - let the AI feedback component handle the priority
  };

  const dispatch = useDispatch();
  const { token } = useAuth();

  const [periodTab, setPeriodTab] = useState("year");
  const [year, setYear] = useState(new Date().getFullYear().toString());
  const [month, setMonth] = useState((new Date().getMonth() + 1).toString());
  const [startdate, setstartdate] = useState(defaultStartDate);
  const [enddate, setenddate] = useState(defaultEndDate);
  const [month_year, setmonth_year] = useState("");
  const [calendarSelectionMade, setCalendarSelectionMade] = useState(false);
  const chatDrawerState = useSelector((state) => state?.ChatDrawerState);

  const [selectstudent, setselectstudent] = useState([]);
  const [isAIGenerating, setIsAIGenerating] = useState(false); // Global AI generation state

  // Helper function to get current date in DD-MM-YYYY format
  const getCurrentDateFormatted = () => {
    const today = new Date();
    const day = today.getDate().toString().padStart(2, '0');
    const month = (today.getMonth() + 1).toString().padStart(2, '0');
    const year = today.getFullYear();
    return `${day}-${month}-${year}`;
  };

  // Helper function to get date a week ago in DD-MM-YYYY format
  const getWeekAgoDateFormatted = () => {
    const today = new Date();
    const weekAgo = new Date(today.getTime() - 7 * 24 * 60 * 60 * 1000);
    const day = weekAgo.getDate().toString().padStart(2, '0');
    const month = (weekAgo.getMonth() + 1).toString().padStart(2, '0');
    const year = weekAgo.getFullYear();
    return `${day}-${month}-${year}`;
  };

  // Helper function to get previous week date range (7 days ending today)
  const getPreviousWeekDates = () => {
    const today = new Date();
    const weekAgo = new Date(today.getTime() - 7 * 24 * 60 * 60 * 1000);

    const startDate = format(weekAgo, "dd-MM-yyyy");
    const endDate = format(today, "dd-MM-yyyy");

    return { startDate, endDate };
  };

  // Add a ref to track if we're currently making an API call
  const isApiCallInProgress = useRef(false);

  const handlePeriodChange = (period, value) => {
    // Handle graph rendering logic here based on period and value (year, month, etc.)
  };
  const handleYearChange = (year) => {
    // Handle graph rendering logic here based on period and value (year, month, etc.)
    setYear(year);
    // Also update month_year when year changes
    if (periodTab === "month" || periodTab === "week" || periodTab === "year") {
      const newMonthYear = `${getMonthName(parseInt(month, 10))}-${year}`;
      setmonth_year(newMonthYear);
      setCalendarSelectionMade(true); // Mark that a calendar selection was made
      // Clear dot data when calendar selection is made
      setdot(null);
    }
  };

  const handleMonthChange = (month) => {
    // Handle graph rendering logic here based on period and value (year, month, etc.)
    setMonth(month);
    // Also update month_year when month changes
    if (periodTab === "month" || periodTab === "week" || periodTab === "year") {
      const newMonthYear = `${getMonthName(parseInt(month, 10))}-${year}`;
      setmonth_year(newMonthYear);
      setCalendarSelectionMade(true); // Mark that a calendar selection was made
      // Clear dot data when calendar selection is made
      setdot(null);
    }
  };
  const handlestartdateChange = (start_date) => {
    setstartdate(start_date);
    setCalendarSelectionMade(true); // Mark that a calendar selection was made
    // Clear dot data when calendar selection is made
    setdot(null);

    // For weekly tab, update month_year based on start_date
    if (periodTab === "week" && start_date) {
      const [day, month, year] = start_date.split('-');
      const monthName = getMonthName(parseInt(month, 10));
      const newMonthYear = `${monthName}-${year}`;
      setmonth_year(newMonthYear);
    }
  };

  const handleenddateChange = (end_date) => {
    setenddate(end_date);
    setCalendarSelectionMade(true); // Mark that a calendar selection was made
    // Clear dot data when calendar selection is made
    setdot(null);
  };

  const handlemonth_yearChange = (month_year) => {
    setmonth_year(month_year);
    setCalendarSelectionMade(true);
    // Clear dot data when calendar selection is made
    setdot(null);
  };

  const theme = useTheme();
  const [value, setValue] = useState("1");
  const globalState = useSelector((state) => state?.globalState);
  const teacher_id = globalState?.teacher_details?.data?.teacher_id;
  const student_id = globalState?.student_details?.data?.student_id;

  const handleChange = (event, newValue) => {
    // Prevent tab changes during AI generation
    if (isAIGenerating) {
      return;
    }

    setValue(newValue);
    // Clear dot data when switching between tabs
    setdot(null);
    if (newValue === "2") {
      dispatch(resetCourseList());
      // Event overview API will be called by the useEffect when switching to tab "2"
    }
  };

  const [activeTab, setActiveTab] = useState("year"); // Default active tab

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  const [state, setState] = useState({
    selection: {
      startDate: new Date(),
      endDate: addDays(new Date(), 5), // Customize the range
      key: "selection",
    },
  });

  const [isOpen, setIsOpen] = useState(false); // State to toggle calendar visibility
  const [selectedCourseData, setselectedCourseData] = useState([]);
  const [selectedStudentData, setSelectedStudentData] = useState([]);
  //console.warn("AllDAta of selected Course and Student:" , selectedCourseData ,selectedStudentData);

  // Function to toggle calendar visibility when the input is clicked

  const handlePeriodTabChange = (event, newValue) => {
    // Prevent period tab changes during AI generation
    if (isAIGenerating) {
      return;
    }

    setPeriodTab(newValue);

    // Reset calendar selection flag when switching tabs
    setCalendarSelectionMade(false);

    // Clear dot data when switching tabs - use null to ensure complete clearing
    setdot(null);

    // Reset calendar to default state for each tab
    const currentDate = new Date();
    const currentMonth = currentDate.getMonth() + 1;
    const currentYear = currentDate.getFullYear();
    const monthName = getMonthName(currentMonth);

    // Handle different tab types with default values
    if (newValue === "week") {
      // For week tab, set current month-year as default
      setstartdate("");
      setenddate("");
      setmonth_year(`${monthName}-${currentYear}`);
      setMonth(currentMonth.toString());
      setYear(currentYear.toString());
    } else if (newValue === "custom") {
      // For custom tab, set previous week dates as default
      const previousWeekDates = getPreviousWeekDates();
      setstartdate(previousWeekDates.startDate);
      setenddate(previousWeekDates.endDate);
      setmonth_year(""); // Clear month_year for custom tab
      setMonth(currentMonth.toString());
      setYear(currentYear.toString());
    } else if (newValue === "month") {
      // For month tab, set current month-year as default
      setstartdate("");
      setenddate("");
      setmonth_year(`${monthName}-${currentYear}`);
      setMonth(currentMonth.toString());
      setYear(currentYear.toString());
    } else if (newValue === "year") {
      // For year tab, set current year as default
      setstartdate("");
      setenddate("");
      setmonth_year(""); // Clear month_year for year tab
      setYear(currentYear.toString());
      setMonth(currentMonth.toString()); // Keep month for calendar display
    }



    // Force a small delay to ensure state updates are processed
    setTimeout(() => {
      console.log('Tab switch completed - periodTab:', newValue, 'month_year:', month_year, 'dot cleared:', !dot);
    }, 100);
  };

  const [courseFilterOpen, setCourseFilterOpen] = useState(false);
  const [studentFilterOpen, setStudentFilterOpen] = useState(false);

  // Create refs for both filters
  const courseFilterRef = useRef(null);
  const studentFilterRef = useRef(null);

  // Function to toggle Course Filter visibility
  const toggleCourseFilter = () => {
    setCourseFilterOpen((prevState) => !prevState);
  };

  // Function to toggle Student Filter visibility
  const toggleStudentFilter = () => {
    setStudentFilterOpen((prevState) => !prevState);
  };

  // Close filter if clicked outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      // Close course filter if clicked outside
      if (
        courseFilterRef.current &&
        !courseFilterRef.current.contains(event.target)
      ) {
        setCourseFilterOpen(false);
      }

      // Close student filter if clicked outside
      if (
        studentFilterRef.current &&
        !studentFilterRef.current.contains(event.target)
      ) {
        setStudentFilterOpen(false);
      }
    };

    // Add event listener for clicks outside the filters
    document.addEventListener("mousedown", handleClickOutside);

    // Clean up the event listener
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // Call event overview API when period changes while on Events Overview tab
  useEffect(() => {
    // Prevent multiple simultaneous API calls
    if (isApiCallInProgress.current) {
      return;
    }

    // Only make API call if we're on Events Overview tab and have required data
    if (value === "2") {
      if (globalState?.role === "Teacher") {
        // Only call API if we have both courses and students selected
        if (selectedCourseData.length > 0 && selectedStudentData.length > 0) {
          isApiCallInProgress.current = true;

          const eventStudentsString = selectedStudentData.join(",");
          const eventCoursesString = selectedCourseData.join(",");

          // For custom tab, ensure we have proper start_date and end_date
          let customStartDate = startdate;
          let customEndDate = enddate;

          if (periodTab === "custom") {
            // If start_date is empty, use previous week dates
            if (!customStartDate || customStartDate === "") {
              const previousWeekDates = getPreviousWeekDates();
              customStartDate = previousWeekDates.startDate;
            }
            // If end_date is empty, use current date
            if (!customEndDate || customEndDate === "") {
              customEndDate = getCurrentDateFormatted();
            }
          }

          const eventData = {
            teacher_id: teacher_id,
            time_period: periodTab,
            courses: eventCoursesString,
            students: eventStudentsString,
            ...((periodTab === "week" ||
              periodTab === "month" ||
              periodTab === "year") && {
              month_year: month_year || `${getMonthName(parseInt(month, 10))}-${year}`,
              month: month,
            }),
            ...(periodTab !== "custom" && { year: year }),
            ...(periodTab === "custom" && {
              start_date: customStartDate,
              end_date: customEndDate,
            }),
          };

          dispatch(getEventOverviewByTeacher(token, eventData)).finally(() => {
            isApiCallInProgress.current = false;
          });
        }
      } else if (globalState?.role === "Student") {
        // Only call API if we have courses selected
        if (selectstudent.length > 0) {
          isApiCallInProgress.current = true;

          const coursesString = Array.isArray(selectstudent)
            ? selectstudent.join(",")
            : "";

          // For custom tab, ensure we have proper start_date and end_date
          let customStartDate = startdate;
          let customEndDate = enddate;

          if (periodTab === "custom") {
            // If start_date is empty, use previous week dates
            if (!customStartDate || customStartDate === "") {
              const previousWeekDates = getPreviousWeekDates();
              customStartDate = previousWeekDates.startDate;
            }
            // If end_date is empty, use current date
            if (!customEndDate || customEndDate === "") {
              customEndDate = getCurrentDateFormatted();
            }
          }

          const eventData = {
            student_id: student_id,
            time_period: periodTab,
            courses: coursesString,
            ...((periodTab === "week" ||
              periodTab === "month" ||
              periodTab === "year") && {
              month_year: month_year || `${getMonthName(parseInt(month, 10))}-${year}`,
              month: month,
            }),
            ...(periodTab !== "custom" && { year: year }),
            ...(periodTab === "custom" && {
              start_date: customStartDate,
              end_date: customEndDate,
            }),
          };

          dispatch(getEventOverviewByStudent(token, eventData)).finally(() => {
            isApiCallInProgress.current = false;
          });
        }
      }
    }
  }, [
    value,
    periodTab,
    year,
    month,
    startdate,
    enddate,
    month_year,
    selectedCourseData,
    selectedStudentData,
    selectstudent,
    globalState?.role,
    teacher_id,
    student_id,
    token,
  ]);

  useEffect(() => {
    return () => {
      dispatch(resetStudentList());
      dispatch(setDrawerState(false));

    };
  }, []);

  // Ensure month_year is always in correct format when periodTab, month, or year changes
  // But only if month_year is not already set by calendar selection
  useEffect(() => {

    if (periodTab && month && year) {
      if (periodTab === "month" || periodTab === "week" || periodTab === "year") {
        // Only set month_year if it's empty and no calendar selection has been made
        // Don't set it if we have dot data (dot is not empty)
        if (!month_year && !calendarSelectionMade && !dot) {
          const newMonthYear = `${getMonthName(parseInt(month, 10))}-${year}`;
          setmonth_year(newMonthYear);
        }
      }
    }
  }, [periodTab, month, year, calendarSelectionMade, month_year, dot]);

  // Helper function to validate and format month_year
  const validateAndFormatMonthYear = (monthYear, currentMonth, currentYear) => {
    // If monthYear is already in correct format (MMM-YYYY), return it
    if (monthYear && /^[A-Za-z]{3}-\d{4}$/.test(monthYear)) {
      return monthYear;
    }

    // If monthYear is just a year (like "2025"), format it with current month
    if (monthYear && /^\d{4}$/.test(monthYear)) {
      return `${getMonthName(parseInt(currentMonth, 10))}-${monthYear}`;
    }

    // If monthYear is empty or invalid, format with current month and year
    if (currentMonth && currentYear) {
      return `${getMonthName(parseInt(currentMonth, 10))}-${currentYear}`;
    }

    return monthYear; // Return as is if we can't format it
  };

  // Static Data for X-Axis (months) and Y-Axis (values)
  //   const staticData = [
  //     { month: 'Jan', value: 0 },
  //     { month: 'Feb',  },
  //     { month: 'Mar',  },
  //     { month: 'Apr',  },
  //     { month: 'May',  },
  //     { month: 'Jun', },
  //     { month: 'Jul', value: 0 },
  //     // { month: 'Aug', value: 30 },
  //     // { month: 'Sep', value: 60 },
  //     // { month: 'Oct', value: 90 },
  //     // { month: 'Nov', value: 20 },
  //     // { month: 'Dec', value: 40 }
  //   ];

  // Log the role, course, and student data when the component is mounted or state changes

  return (
    <div
      className={
        globalState?.role === "Student"
          ? "overall-performance-dashboard-section container-fluid"
          : "overall-performance-dashboard-section"
      }
    >
      {globalState?.role === "Teacher" ? (
        <h2 className="overall-performance-analytics-title">Analytics</h2>
      ) : (
        <h2 className="my-academic-report-title">My Academic Report</h2>
      )}
      <div className="overall-performance-dashboard-wrapper">
        <div className="overall-performance-dashboard-tabs">
          <Box sx={{ width: "100%", typography: "body1" }}>
            <TabContext value={value}>
              <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                <TabList
                  onChange={handleChange}
                  aria-label="lab API tabs example"
                  disabled={isAIGenerating}
                  sx={{
                    opacity: isAIGenerating ? 0.5 : 1,
                    pointerEvents: isAIGenerating ? 'none' : 'auto'
                  }}
                >
                  <Tab
                    sx={{ textTransform: "none" }}
                    label="Overall Performance"
                    value="1"
                  />
                  <Tab
                    sx={{ textTransform: "none" }}
                    label="Events Overview"
                    value="2"
                  />
                </TabList>
              </Box>
              <div className="overall-performance-dashboard-main-section">
                <div className="overall-performance-dashboard-main-wrapper">
                  <div className="overall-performance-dashboard-left-section">
                    <div className="mobile-course-students-filter">
                      <div className="mobile-course-filter">
                        <h4>Select Course</h4>
                        <div
                          className="mobile-course-filter-dropdown"
                          onClick={isAIGenerating ? undefined : toggleCourseFilter}
                          style={{
                            opacity: isAIGenerating ? 0.5 : 1,
                            cursor: isAIGenerating ? 'not-allowed' : 'pointer'
                          }}
                        >
                          <p>All Selected</p>
                          <img src={tooltip_trangle} alt="Tooltip" />
                        </div>
                      </div>
                      {globalState?.role === "Teacher" && (
                        <div className="mobile-student-filter">
                          <h4>Select Students</h4>
                          <div
                            className="mobile-student-filter-dropdown"
                            onClick={isAIGenerating ? undefined : toggleStudentFilter}
                            style={{
                              opacity: isAIGenerating ? 0.5 : 1,
                              cursor: isAIGenerating ? 'not-allowed' : 'pointer'
                            }}
                          >
                            <p>All Selected</p>
                            <img src={tooltip_trangle} alt="Tooltip" />
                          </div>
                        </div>
                      )}
                    </div>
                    <div
                      className={`overall-performance-filter-desktopside ${globalState?.role === "Student" ? "student-side" : ""
                        }`}
                    >
                      <div className="course-filter-desktopside">
                        <CoursesSelectFilter
                          selectstudent={selectstudent}
                          setselectstudent={setselectstudent}
                          setselectedCourseData={setselectedCourseData}
                          periodTab={periodTab}
                          year={year}
                          month={month}
                          start_date={startdate}
                          end_date={enddate}
                          month_year={month_year}
                          value={value}
                          isAIGenerating={isAIGenerating}
                        />
                      </div>
                      <div className="student-filter-desktopside">
                        {globalState?.role === "Teacher" && (
                          <StudentSelectfilter
                            selectedCourseData={selectedCourseData}
                            periodTab={periodTab}
                            year={year}
                            month={month}
                            start_date={startdate}
                            end_date={enddate}
                            month_year={month_year}
                            setSelectedStudentData={setSelectedStudentData}
                            value={value}
                            isAIGenerating={isAIGenerating}
                          />
                        )}
                      </div>
                    </div>

                    <div className="overall-performance-filter-mobileside">
                      {/* Conditional Rendering for Mobile Filters */}

                      {(courseFilterOpen || studentFilterOpen) && (
                        <div
                          className="backdrop"
                          onClick={() => {
                            setCourseFilterOpen(false); // Close course filter
                            setStudentFilterOpen(false); // Close student filter
                          }}
                        />
                      )}
                      {/* Keep mobile filters MOUNTED and toggle visibility with CSS.
                          Conditional mounting caused StudentSelectfilter to mount fresh
                          (empty state) after courses were picked, showing
                          "No students available yet". Always-mounted, its effect
                          watching selectedCourseData fires like on desktop. */}
                      <div
                        className="course-filter-mobileside"
                        ref={courseFilterRef}
                        style={{ display: courseFilterOpen ? "block" : "none" }}
                      >
                        <CoursesSelectFilter
                          selectstudent={selectstudent}
                          setselectstudent={setselectstudent}
                          setselectedCourseData={setselectedCourseData}
                          periodTab={periodTab}
                          year={year}
                          month={month}
                          start_date={startdate}
                          end_date={enddate}
                          month_year={month_year}
                          value={value}
                        />
                      </div>

                      <div
                        className="student-filter-mobileside"
                        ref={studentFilterRef}
                        style={{ display: studentFilterOpen ? "block" : "none" }}
                      >
                        {globalState?.role === "Teacher" && (
                          <StudentSelectfilter
                            selectedCourseData={selectedCourseData}
                            periodTab={periodTab}
                            year={year}
                            month={month}
                            start_date={startdate}
                            end_date={enddate}
                            month_year={month_year}
                            setSelectedStudentData={setSelectedStudentData}
                            value={value}
                          />
                        )}
                      </div>
                    </div>

                    {/* <CoursesSelectFilter  setselectedCourseData={setselectedCourseData} periodTab ={periodTab} year ={year} month ={month} start_date ={startdate} end_date ={enddate} month_year={month_year}  />
                       { globalState?.role === "Teacher" &&  <StudentSelectfilter selectedCourseData ={selectedCourseData} periodTab ={periodTab} year ={year} month ={month} start_date ={startdate} end_date ={enddate} month_year={month_year}   setSelectedStudentData ={setSelectedStudentData}/>} */}
                  </div>
                  <div className="overall-performance-dashboard-center-section">
                    <TabPanel value="1">
                      <div className="overall-performance-graph-section">
                        <div className="overall-performance-graph-wrapper">
                          <h3>Overall Performance</h3>
                          <div className="overall-performance-graph-header">
                            <div className="overall-performance-graph-tab">
                              <TabPanel
                                value={value}
                                index={0}
                                dir={theme.direction}
                                className="period-tabs"
                                sx={{
                                  padding: 0,
                                }}
                              >
                                <div>
                                  <Tabs
                                    value={periodTab}
                                    onChange={handlePeriodTabChange}
                                    indicatorColor="secondary"
                                    textColor="inherit"
                                    variant="scrollable"
                                    scrollButtons="auto"
                                    aria-label="period tabs"
                                    disabled={isAIGenerating}
                                    sx={{
                                      padding: 0, // Remove padding
                                      minHeight: "40px", // Set a minimum height for all tabs
                                      opacity: isAIGenerating ? 0.5 : 1,
                                      pointerEvents: isAIGenerating ? 'none' : 'auto',
                                      // Keep tab labels in sentence case instead of MUI's default uppercase
                                      "& .MuiTab-root": { textTransform: "none" }
                                    }}
                                  >
                                    <Tab
                                      label="Custom"
                                      value="custom"
                                      sx={{
                                        color: "#555555", // Text color for inactive tabs
                                        fontSize: "11px", // Font size for all tabs
                                        padding: "0", // Remove padding for tab
                                        minHeight: "30px", // Set a minimum height for all tabs
                                        minWidth: "70px", // Set a minimum width for all tabs
                                        borderRadius: "0", // No border radius for inactive tabs
                                        "&.Mui-selected": {
                                          color: "white", // Active tab text color
                                          backgroundColor: "#0068FF", // Active tab background color
                                          borderRadius: "20px", // Add border radius to active tab
                                          minHeight: "30px",
                                        },
                                      }}
                                    />
                                    <Tab
                                      label="Weekly"
                                      value="week"
                                      sx={{
                                        color: "#555555",
                                        fontSize: "11px",
                                        padding: "0",
                                        minHeight: "30px", // Set a minimum height for all tabs
                                        minWidth: "70px",
                                        borderRadius: "0",
                                        "&.Mui-selected": {
                                          color: "white",
                                          backgroundColor: "#0068FF",
                                          borderRadius: "20px",
                                          minHeight: "30px",
                                        },
                                      }}
                                    />
                                    <Tab
                                      label="Monthly"
                                      value="month"
                                      sx={{
                                        color: "#555555",
                                        fontSize: "11px",
                                        padding: "0",
                                        minHeight: "30px", // Set a minimum height for all tabs
                                        minWidth: "70px",
                                        borderRadius: "0",
                                        "&.Mui-selected": {
                                          color: "white",
                                          backgroundColor: "#0068FF",
                                          borderRadius: "20px",
                                          minHeight: "30px",
                                        },
                                      }}
                                    />
                                    <Tab
                                      label="Yearly"
                                      value="year"
                                      sx={{
                                        color: "#555555",
                                        fontSize: "11px",
                                        padding: "0",
                                        minHeight: "30px", // Set a minimum height for all tabs
                                        minWidth: "70px",
                                        borderRadius: "0",
                                        "&.Mui-selected": {
                                          color: "white",
                                          backgroundColor: "#0068FF",
                                          borderRadius: "20px",
                                          minHeight: "30px",
                                        },
                                      }}
                                    />
                                  </Tabs>
                                </div>
                              </TabPanel>

                              {/* <div className="tabs">
                                                                <button
                                                                    className={`tab-button ${activeTab === 'Custom' ? 'active' : ''}`}
                                                                    onClick={() => handleTabClick('Custom')}
                                                                >
                                                                    Custom
                                                                </button>
                                                                <button
                                                                    className={`tab-button ${activeTab === 'Weekly' ? 'active' : ''}`}
                                                                    onClick={() => handleTabClick('Weekly')}
                                                                >
                                                                    Weekly
                                                                </button>
                                                                <button
                                                                    className={`tab-button ${activeTab === 'Monthly' ? 'active' : ''}`}
                                                                    onClick={() => handleTabClick('Monthly')}
                                                                >
                                                                    Monthly
                                                                </button>
                                                                <button
                                                                    className={`tab-button ${activeTab === 'Yearly' ? 'active' : ''}`}
                                                                    onClick={() => handleTabClick('Yearly')}
                                                                >
                                                                    Yearly
                                                                </button>
                                                            </div> */}
                            </div>
                            <div className="overall-performance-graph-calendar">
                              <div className="custom-date-picker">
                                {/* <CalendarView defaultView={(periodTab === 1 || periodTab === 2) ? "month" : "year"} periodTabTwo={periodTab} /> */}
                                <CalendarView
                                  defaultView={
                                    periodTab === "week" ||
                                      periodTab === "month"
                                      ? "month"
                                      : "year"
                                  }
                                  periodTabTwo={periodTab}
                                  onPeriodChange={handlePeriodChange} // Pass the handler function
                                  onYearChange={handleYearChange}
                                  onMonthChange={handleMonthChange}
                                  onstartdatechange={handlestartdateChange}
                                  onenddatechange={handleenddateChange}
                                  onmonth_yearchnage={handlemonth_yearChange}
                                  setdot={handleDotClick}
                                  isAIGenerating={isAIGenerating}
                                  externalYear={year}
                                  externalMonth={month}
                                  externalMonthYear={month_year}
                                  externalStartDate={startdate}
                                  externalEndDate={enddate}
                                />
                                {/* <div className="date-picker-input-container" onClick={toggleCalendar}>
                                                                    <div className="calendar-icon-inner">
                                                                        <img src={calendar_icn} alt="Calendar Icon" />
                                                                    </div>
                                                                    <input
                                                                        type="text"
                                                                        readOnly
                                                                        value={`${state.selection.startDate.toLocaleDateString()} - ${state.selection.endDate.toLocaleDateString()}`}
                                                                        //value={`${state.selection.startDate.toLocaleDateString()}`}
                                                                        onClick={toggleCalendar}
                                                                        className="date-picker-input"
                                                                    />
                                                                </div> */}

                                {/* {isOpen && (
                                                                    <DateRange
                                                                        editableDateInputs={true}
                                                                        onChange={(item) => setState({ ...state, ...item })}
                                                                        moveRangeOnFirstSelection={false}
                                                                        ranges={[state.selection]}
                                                                        locale={enUS}
                                                                        className="calendar-popup"
                                                                    />
                                                                )} */}
                              </div>
                            </div>
                          </div>
                          {/* <div className="tab-content">
                                                        {periodTab === 'Custom' &&
                                                            <div>
                                                                <OverallPerformanceGraph />
                                                            </div>
                                                        }
                                                        {periodTab === 'Weekly' &&
                                                            <div>
                                                                <OverallPerformanceGraph />
                                                            </div>
                                                        }
                                                        {periodTab === 'Monthly' &&
                                                            <div>
                                                                <OverallPerformanceGraph />
                                                            </div>
                                                        }
                                                        {periodTab === 'Yearly' &&
                                                            <div>
                                                                <OverallPerformanceGraph />
                                                            </div>
                                                        }
                                                    </div> */}
                          <div className="tab-content">
                            <h5>Average Score</h5>

                            {(globalState?.role === "Teacher" ? (
                              selectedCourseData.length === 0 ||
                              selectedStudentData.length === 0 // For teachers: both course and student should be selected
                            ) : (
                              selectstudent.length === 0
                            )) ? ( // For students: only course should be selected
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  height: "60vh",
                                  color: "#666",
                                  fontSize: "16px",
                                  position: "relative",
                                }}
                              >
                                {globalState?.role === "Teacher" ? (
                                  <>
                                    <div className="error-message-overviewperformence-dashboard">
                                      <div className="error-message-overviewperformence-dashboard-image">
                                        <img
                                          src={Chart_data}
                                          alt="No courses found"
                                        />
                                      </div>
                                      <p>
                                        Seems like there is no data to show on
                                        this graph yet
                                      </p>
                                    </div>
                                    {/* <ResponsiveContainer width="100%" height="100%">
                                                                            <AreaChart
                                                                                data={staticData} 
                                                                                margin={{
                                                                                top: 20,
                                                                                right: 0,
                                                                                left: 0,
                                                                                bottom: 40,  
                                                                                }}
                                                                            >
                                                                                <CartesianGrid
                                                                                strokeDasharray="none"
                                                                                stroke="#f0f0f0"
                                                                                horizontal={true}
                                                                                vertical={false}
                                                                                />

                                                                                
                                                                                <XAxis
                                                                                dataKey="month"
                                                                                axisLine={true} 
                                                                                tickLine={false} 
                                                                                tickMargin={10}
                                                                                fontSize={12}
                                                                                />

                                                                                
                                                                                <YAxis
                                                                                axisLine={{ stroke: '#D3D3D3', strokeWidth: 1 }} 
                                                                                tickLine={false}  
                                                                                tick={{ fontSize: 12, fill: '#666' }}
                                                                                tickFormatter={(value) => `${value}%`} 
                                                                                ticks={[0, 25, 50, 75, 100]} 
                                                                                />

                                                                                
                                                                                <Area
                                                                                type="monotone"
                                                                                dataKey="value"  
                                                                                stroke="#4A90E2"
                                                                                strokeWidth={2}
                                                                                fill="#4A90E2"
                                                                                fillOpacity={0.2}
                                                                                />

                                                                                
                                                                            </AreaChart>
                                                                        </ResponsiveContainer> */}
                                  </>
                                ) : (
                                  <>
                                    <div className="error-message-overviewperformence-dashboard">
                                      <div className="error-message-overviewperformence-dashboard-image">
                                        <img
                                          src={Chart_data}
                                          alt="No courses found"
                                        />
                                      </div>
                                      <p>
                                        Seems like there is no data to show on
                                        this graph yet
                                      </p>
                                    </div>
                                  </>
                                )}
                              </div>
                            ) : (
                              <OverallPerformanceGraph
                                periodTab={periodTab}
                                selectedCourseData={selectedCourseData}
                                selectedStudentData={selectedStudentData}
                                year={year}
                                month={month}
                                startdate={startdate}
                                enddate={enddate}
                                monthYear={month_year}
                                selectstudent={selectstudent}
                                setdot={handleDotClick}
                                isAIGenerating={isAIGenerating}
                              />
                            )}

                            {/* {selectedCourseData.length === 0 || selectedStudentData.length === 0 ? (
                                                         <div style={{ 
                                                             display: 'flex', 
                                                            justifyContent: 'center', 
                                                            alignItems: 'center', 
                                                            height: '300px',
                                                             color: '#666',
                                                            fontSize: '16px'
                                                            }}> No Course and student selected yet</div>
                                                      ) : (

                                                        <OverallPerformanceGraph periodTab={periodTab} selectedCourseData={selectedCourseData} selectedStudentData={selectedStudentData} year={year} month={month} startdate={startdate} enddate={enddate} monthYear={month_year} />
                                                     )} */}
                            {/* {periodTab === 'custom' && <OverallPerformanceGraph periodTab={periodTab} selectedCourseData={selectedCourseData} selectedStudentData={selectedStudentData} />}
                                                        {periodTab === 'week' && <OverallPerformanceGraph periodTab={periodTab} selectedCourseData={selectedCourseData} selectedStudentData={selectedStudentData} />}
                                                        {periodTab === 'month' && <OverallPerformanceGraph periodTab={periodTab} selectedCourseData={selectedCourseData} selectedStudentData={selectedStudentData} />}
                                                        {periodTab === 'year' && <OverallPerformanceGraph periodTab={periodTab} selectedCourseData={selectedCourseData} selectedStudentData={selectedStudentData} />} */}
                            {/* <OverallPerformanceGraph periodTab={periodTab} selectedCourseData={selectedCourseData} selectedStudentData={selectedStudentData} year={year} month={month} startdate={startdate} enddate={enddate} monthYear={month_year} /> */}
                          </div>
                        </div>
                      </div>
                    </TabPanel>
                    <TabPanel value="2">
                      <div className="overall-performance-graph-section">
                        <div className="overall-performance-graph-wrapper">
                          <h3>Event Overview</h3>
                          <div className="overall-performance-graph-header">
                            <div className="overall-performance-graph-tab">

                              <TabPanel
                                value={value}
                                index={0}
                                dir={theme.direction}
                                className="period-tabs"
                                sx={{
                                  padding: 0,
                                }}
                              >
                                <div>
                                  <Tabs
                                    value={periodTab}
                                    onChange={handlePeriodTabChange}
                                    indicatorColor="secondary"
                                    textColor="inherit"
                                    variant="scrollable"
                                    scrollButtons="auto"
                                    aria-label="period tabs"
                                    disabled={isAIGenerating}
                                    sx={{
                                      padding: 0, // Remove padding
                                      minHeight: "40px", // Set a minimum height for all tabs
                                      opacity: isAIGenerating ? 0.5 : 1,
                                      pointerEvents: isAIGenerating ? 'none' : 'auto',
                                      // Keep tab labels in sentence case instead of MUI's default uppercase
                                      "& .MuiTab-root": { textTransform: "none" }
                                    }}
                                  >
                                    <Tab
                                      label="Custom"
                                      value="custom"
                                      sx={{
                                        color: "#555555", // Text color for inactive tabs
                                        fontSize: "11px", // Font size for all tabs
                                        padding: "0", // Remove padding for tab
                                        minHeight: "30px", // Set a minimum height for all tabs
                                        minWidth: "70px", // Set a minimum width for all tabs
                                        borderRadius: "0", // No border radius for inactive tabs
                                        "&.Mui-selected": {
                                          color: "white", // Active tab text color
                                          backgroundColor: "#0068FF", // Active tab background color
                                          borderRadius: "20px", // Add border radius to active tab
                                          minHeight: "30px",
                                        },
                                      }}
                                    />
                                    <Tab
                                      label="Weekly"
                                      value="week"
                                      sx={{
                                        color: "#555555",
                                        fontSize: "11px",
                                        padding: "0",
                                        minHeight: "30px", // Set a minimum height for all tabs
                                        minWidth: "70px",
                                        borderRadius: "0",
                                        "&.Mui-selected": {
                                          color: "white",
                                          backgroundColor: "#0068FF",
                                          borderRadius: "20px",
                                          minHeight: "30px",
                                        },
                                      }}
                                    />
                                    <Tab
                                      label="Monthly"
                                      value="month"
                                      sx={{
                                        color: "#555555",
                                        fontSize: "11px",
                                        padding: "0",
                                        minHeight: "30px", // Set a minimum height for all tabs
                                        minWidth: "70px",
                                        borderRadius: "0",
                                        "&.Mui-selected": {
                                          color: "white",
                                          backgroundColor: "#0068FF",
                                          borderRadius: "20px",
                                          minHeight: "30px",
                                        },
                                      }}
                                    />
                                    <Tab
                                      label="Yearly"
                                      value="year"
                                      sx={{
                                        color: "#555555",
                                        fontSize: "11px",
                                        padding: "0",
                                        minHeight: "30px", // Set a minimum height for all tabs
                                        minWidth: "70px",
                                        borderRadius: "0",
                                        "&.Mui-selected": {
                                          color: "white",
                                          backgroundColor: "#0068FF",
                                          borderRadius: "20px",
                                          minHeight: "30px",
                                        },
                                      }}
                                    />
                                  </Tabs>
                                </div>
                              </TabPanel>
                            </div>
                            <div className="overall-performance-graph-calendar">
                              <div className="custom-date-picker">
                                {/* Input field with calendar icon */}
                                <CalendarView
                                  defaultView={
                                    periodTab === "week" ||
                                      periodTab === "month"
                                      ? "month"
                                      : "year"
                                  }
                                  periodTabTwo={periodTab}
                                  onPeriodChange={handlePeriodChange} // Pass the handler function
                                  onYearChange={handleYearChange}
                                  onMonthChange={handleMonthChange}
                                  onstartdatechange={handlestartdateChange}
                                  onenddatechange={handleenddateChange}
                                  onmonth_yearchnage={handlemonth_yearChange}
                                  setdot={handleDotClick}
                                  isAIGenerating={isAIGenerating}
                                  externalYear={year}
                                  externalMonth={month}
                                  externalMonthYear={month_year}
                                  externalStartDate={startdate}
                                  externalEndDate={enddate}
                                />
                                {/* <div className="date-picker-input-container" onClick={toggleCalendar}>
                                                                    <div className="calendar-icon-inner">
                                                                        <img src={calendar_icn} alt="Calendar Icon" />
                                                                    </div>
                                                                    <input
                                                                        type="text"
                                                                        readOnly
                                                                        value={`${state.selection.startDate.toLocaleDateString()} - ${state.selection.endDate.toLocaleDateString()}`}
                                                                        // value={`${state.selection.startDate.toLocaleDateString()}`}
                                                                        onClick={toggleCalendar}
                                                                        className="date-picker-input"
                                                                    />
                                                                </div> */}

                                {/* Date range calendar */}
                                {/* {isOpen && (
                                                                    <DateRange
                                                                        editableDateInputs={true}
                                                                        onChange={(item) => setState({ ...state, ...item })}
                                                                        moveRangeOnFirstSelection={false}
                                                                        ranges={[state.selection]}
                                                                        locale={enUS}
                                                                        className="calendar-popup"
                                                                    />
                                                                )} */}
                              </div>
                            </div>
                          </div>
                          <div className="tab-content">

                            <div className="overall-performance-graph-legend">
                              <div className="event-overview-Ggraph-title">
                                Score
                              </div>
                              <div className="event-overview-Ggraph-legend-label-folder">
                                <div className="event-overview-Ggraph-legend-label">
                                  <div
                                    style={{
                                      width: "12px",
                                      height: "12px",
                                      borderRadius: "50%",
                                      backgroundColor: "#FF8C42",
                                      border: "2px solid #FF8C42",
                                    }}
                                  ></div>
                                  <span style={{ color: "#666" }}>
                                    Practice Assignment
                                  </span>
                                </div>
                                <div className="event-overview-Ggraph-legend-label">
                                  <div
                                    style={{
                                      width: "12px",
                                      height: "12px",
                                      borderRadius: "50%",
                                      backgroundColor: "#4A90E2",
                                      border: "2px solid #4A90E2",
                                    }}
                                  ></div>
                                  <span style={{ color: "#666" }}>
                                    Course Assignment
                                  </span>
                                </div>
                                <div className="event-overview-Ggraph-legend-label">
                                  <div
                                    style={{
                                      width: "12px",
                                      height: "12px",
                                      borderRadius: "50%",
                                      backgroundColor: "#9B59B6",
                                      border: "2px solid #9B59B6",
                                    }}
                                  ></div>
                                  <span style={{ color: "#666" }}>
                                    Test Prep
                                  </span>
                                </div>
                              </div>
                            </div>
                            {(globalState?.role === "Teacher" ? (
                              selectedCourseData.length === 0 ||
                              selectedStudentData.length === 0 // For teachers: both course and student should be selected
                            ) : (
                              selectstudent.length === 0
                            )) ? ( // For students: only course should be selected
                              <div
                              // style={{
                              //     display: 'flex',
                              //     justifyContent: 'center',
                              //     alignItems: 'center',
                              //     height: '300px',
                              //     color: '#666',
                              //     fontSize: '16px'
                              //  }}
                              >
                                {globalState?.role === "Teacher" ? (
                                  <div className="error-message-overviewperformence-dashboard error-message-graph">
                                    <div className="error-message-overviewperformence-dashboard-image">
                                      <img
                                        src={Chart_data}
                                        alt="No courses found"
                                      />
                                    </div>
                                    <p>
                                      Seems like there is no data to show on
                                      this graph yet
                                    </p>
                                  </div>
                                ) : (
                                  <div className="error-message-overviewperformence-dashboard error-message-graph">
                                    <div className="error-message-overviewperformence-dashboard-image">
                                      <img
                                        src={Chart_data}
                                        alt="No courses found"
                                      />
                                    </div>
                                    <p>
                                      Seems like there is no data to show on
                                      this graph yet
                                    </p>
                                  </div>
                                )}
                              </div>
                            ) : (
                              <EventOverViewGraph
                                selectedCourseData={selectedCourseData}
                                selectedStudentData={selectedStudentData}
                                setdot={handleDotClick}
                                periodTab={periodTab}
                                monthYear={month_year}
                                year={year}
                                month={month}
                                startdate={startdate}
                                enddate={enddate}
                                isAIGenerating={isAIGenerating}
                              />
                            )}
                          </div>
                          {/* <EventOverViewGraph /> */}
                        </div>
                      </div>
                    </TabPanel>
                  </div>
                  <div className="overall-performance-dashboard-right-section">

                    <AIFeedbackPerformance
                      selectstudent={selectstudent}
                      setselectstudent={setselectstudent}
                      periodTab={periodTab}
                      setPeriodTab={setPeriodTab}
                      globalState={globalState}
                      selectedCourseData={selectedCourseData}
                      selectedStudentData={selectedStudentData}
                      dot={dot}
                      setdot={handleDotClick}
                      year={year}
                      month={month}
                      startdate={startdate}
                      enddate={enddate}
                      month_year={month_year}
                      value={value}
                      setValue={setValue}
                      isAIGenerating={isAIGenerating}
                      setIsAIGenerating={setIsAIGenerating}
                    />
                  </div>
                </div>
              </div>
            </TabContext>
          </Box>
        </div>
      </div>
      <FloatingAIButton
        onClick={() => {
          dispatch(setDrawerState(!chatDrawerState.isOpen));
          dispatch(setIsWebAllowed(true));
          dispatch(setQueryMetaData(null));
        }}
      />
    </div>
  );
};

export default OverallPerformanceDashboard;